import React, { useState, useEffect } from 'react'
import Image from 'next/image'
import Link from 'next/link'
export default function Hero({ firmData }) {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 400)
    }
    
    checkMobile()
    window.addEventListener('resize', checkMobile)
    
    return () => window.removeEventListener('resize', checkMobile)
  }, [])

  return (

    <div className='w-full bg-[#8a6e5a] '>
      <div className="w-full h-[720px] md:h-[656px] relative overflow-hidden bg-[#EFEBE4]">
        {/* Background Video */}
        <div className="absolute inset-0 w-full h-full overflow-hidden">
          {isMobile ? (
            <iframe
              src="https://player.vimeo.com/video/1132496641?badge=0&autopause=0&player_id=0&app_id=58479&background=1&autoplay=1&loop=1&muted=1"
              className="absolute w-full"
              frameBorder="0"
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
              style={{ 
                width: '100vw',
                height: 'calc(100vw * 9 / 16)',
                minHeight: '100%',
                minWidth: '100%',
                left: '50%',
                top: '50%',
                transform: 'translate(-50%, -50%)'
              }}
            />
          ) : (
            <video
              className="w-full h-full object-cover"
              autoPlay
              muted
              loop
              playsInline
            >
              <source
                src="https://player.vimeo.com/progressive_redirect/playback/1119780896/rendition/720p/file.mp4?loc=external&signature=63672524f17754b242b82481b79afd33def5513206e6b37eb4a026b169ab1f6d"
                // src="https://framerusercontent.com/assets/RDQGql1a4Ox6yNHkaWijZ8yGcI.mp4"
                //src="/static/videos/hero.mp4"
                type="video/mp4" />
              {/* Fallback image if video doesn't load */}
              <div className="w-full h-full bg-gradient-to-br " />
            </video>
          )}
          {/* Overlay for better text readability */}
          <div
            className="absolute inset-0"
          // className="absolute inset-0 bg-black/20" 
          />
        </div>

        {/* Desktop Content */}
        <div className="hidden md:block relative z-10 w-full h-full flex items-start pt-[106px]">
          <div className="w-[624px] ml-[118px] flex flex-col justify-start items-start gap-8">
            <div className="self-stretch flex flex-col justify-start items-start gap-4">
              <div className="self-stretch flex flex-col justify-start items-start">
                <div className="self-stretch justify-start text-white text-5xl font-medium font-['Lora'] leading-[56px]">
                  {firmData?.hero_title || "Join Us Where Faith Meets Finance & Become a Certified Kingdom Advisor®"}
                </div>
              </div>
              <div className="w-[600px] justify-start text-white text-lg font-normal font-['Instrument-Sans'] leading-7">
                {firmData?.hero_subtext || "Get the designation that's the gold standard for Christian financial advisors."}
              </div>
            </div>

            <div className='w-full flex justify-start items-center'>
              <Link href={firmData?.get_certified_url || "https://dashboard.kingdomadvisors.com/cka"} target='_blank' rel='noopener noreferrer'>
                <div className="w-full md:w-auto px-8 py-4 bg-[#FBB35C] rounded inline-flex justify-center items-center gap-2.5 hover:bg-[#FBB35C] transition-colors cursor-pointer">
                  <div className="w-6 h-6 relative">
                    <Image
                      src="/static/images/cka_landing/blue_arrows.svg"
                      alt="Arrow"
                      width={24}
                      height={24}
                    />
                  </div>
                  <div className="justify-start text-blue-950 text-base font-medium font-['Instrument-Sans']">
                    Get Certified
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>

        {/* Mobile Content */}
        <div className="md:hidden relative z-10 w-full h-full px-4 flex flex-col justify-end items-start gap-2.5 ">
          <div className="self-stretch flex flex-col justify-start items-start gap-8">
            <div className="self-stretch flex flex-col justify-start items-start gap-4">
              <div className="self-stretch flex flex-col justify-start items-start">
                <div className="self-stretch justify-start text-white text-3xl font-medium font-['Lora']">
                  {firmData?.hero_title || "Join Us Where Faith Meets Finance & Become a Certified Kingdom Advisor®"}
                </div>
              </div>
              <div className="self-stretch justify-start text-white text-base font-normal font-['Instrument-Sans'] leading-normal">
                {firmData?.hero_subtext || "Get the designation that's the gold standard for Christian financial advisors."}
              </div>
            </div>


            <div className='w-full md:px-4 flex justify-center items-center mb-4 ' >
            <Link className='w-full' href={firmData?.get_certified_url || "https://dashboard.kingdomadvisors.com/cka"} target='_blank' rel='noopener noreferrer'>
              <div className="w-full md:w-auto px-8 py-4 bg-[#FBB35C] rounded inline-flex justify-center items-center gap-2.5 hover:bg-[#FBB35C] transition-colors cursor-pointer">
                <div className="w-6 h-6 relative">
                  <Image
                    src="/static/images/cka_landing/blue_arrows.svg"
                    alt="Arrow"
                    width={24}
                    height={24}
                  />
                </div>
                <div className="justify-start text-blue-950 text-base font-medium font-['Instrument-Sans']">
                  Get Certified
                </div>
              </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}